import React from 'react';

const ScorecardPlaceholder = () => <span>No scorecard for this match</span>;

export default ScorecardPlaceholder;
